// extracted by mini-css-extract-plugin
module.exports = {"Video":"Video_Video__AuVJx","Video--IsBackground":"Video_Video--IsBackground__3_8AR"};